import { onClickOutside } from "../common/helpers";

const HEIGHT = 0;
const MAX_HEIGHT = 600;

const toPixels = (value) => `${value}px`;

const initElement = ($el) => {
    const $input = $el.querySelector(".ns-singleselect__input");
    const $title = $el.querySelector(".ns-singleselect__title");
    const $dropdown = $el.querySelector(".ns-singleselect__dropdown");
    const radios = $el.querySelectorAll(".ns-radio__input");
    let isOpened = false;

    const handleOpen = () => {
        $title.setAttribute('aria-expanded', 'true');
        $dropdown.removeAttribute('inert');
        $el.classList.add("ns-singleselect--active");
        $dropdown.style.maxHeight = toPixels(MAX_HEIGHT);
    };

    const handleClose = () => {
        $title.setAttribute('aria-expanded', 'false');
        $dropdown.setAttribute('inert', 'true');
        $el.classList.remove("ns-singleselect--active");
        $dropdown.style.maxHeight = HEIGHT;
    };

    const dispatchOnChange = (value) => {
        $el.dispatchEvent(
            new CustomEvent("on-change", {
                detail: {
                    value,
                },
            })
        );
    };

    const setValue = (value) => {
        const title = $title.dataset.title;

        $input.value = value;

        if (value) {
            $title.textContent = $el.querySelector(`.ns-radio__input[value='${value}']`).dataset.textValue;
            $title.ariaLabel = `${title}: ${$title.textContent}`
        } else {
            $title.textContent = $title.ariaLabel = title;
        }

        dispatchOnChange(value);
    };

    const handleAddValue = (value) => {
        const $radio = $el.querySelector(`[value="${value}"]`);

        if (!$radio) {
            return;
        }

        $radio.checked = true;

        setValue(value);
    };

    const handleRemoveValue = (value) => {
        const currentValue = $input.value ? $input.value.split(",") : [];
        const nextValue = currentValue.filter((v) => v !== value);
        const $radio = $el.querySelector(`[value="${value}"]`);

        if (!$radio) {
            return;
        }

        $radio.checked = false;

        setValue(nextValue);
    };

    const handleClearValue = () => {
        setValue([])

        radios.forEach(($radio) => {
            $radio.checked = false;
        });

        dispatchOnChange("");
    };

    const handleChange = (event, $radio) => {
        const checked = event.currentTarget.checked;

        for (const radio of radios) {
            radio.checked = false;
        }

        const value = $radio.value;

        if (checked) {
            handleAddValue(value);
        } else {
            handleRemoveValue(value);
        }
    };

    $title.addEventListener("click", () => {
        if (isOpened === false) {
            handleOpen();
        } else {
            handleClose();
        }

        isOpened = !isOpened;
    });

    onClickOutside($el, () => {
        handleClose();

        isOpened = false;
    });

    radios.forEach(($radio) => {
        $radio.addEventListener("change", (event) => {
            handleChange(event, $radio);
        });
    });

    $el.addEventListener("handle-remove-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleRemoveValue(value);
    });

    $el.addEventListener("handle-add-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleAddValue(value);
    });

    $el.addEventListener("handle-clear-value", handleClearValue);
};

const initElementMobile = ($el) => {
    const title = $el.querySelector('.ns-singleselect-mobile__title');
    const tag = title.dataset.tag;
    const frame = document.querySelector(`.ns-singleselect-mobile__frame[data-tag='${tag}']`);
    const back = frame.querySelector('.ns-singleselect-mobile__frame-top-back');
    const inputs = frame.querySelectorAll(".ns-radio__input");
    const confirmSelection = frame.querySelector('.ns-singleselect-mobile__frame-confirm');
    let isOpened = false;

    const handleOpen = () => {
        frame.classList.add("ns-singleselect-mobile__frame--active");
        isOpened = true;
    };

    const handleBack = () => {
        frame.classList.remove("ns-singleselect-mobile__frame--active");
        isOpened = false;
    }

    const handleChange = event => {
        for (const input of inputs) {
            input.checked = false;
        }

        event.currentTarget.checked = true;
    };

    title.addEventListener('click', handleOpen);
    back.addEventListener('click', handleBack);

    for (const input of inputs) {
        input.addEventListener('change', handleChange);
    }

    confirmSelection.addEventListener('click', handleBack);
};

const init = () => {
    const singleselects = document.querySelectorAll(".ns-singleselect");
    const singleselectsMobile = document.querySelectorAll(".ns-singleselect-mobile");

    singleselects.forEach(($el) => {
        initElement($el);
    });
    singleselectsMobile.forEach(($el) => {
        initElementMobile($el);
    });
};

window.addEventListener("DOMContentLoaded", init, false);
